import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ActivatedRoute } from '@angular/router';
import { MediaCellConfig } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
    selector: "lazy-item-list",
    templateUrl: "./lazy-item-list.template.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class LazyItemList implements OnInit {
    @Input() list: any;
    @Input() config: MediaCellConfig;
    @Input() paginate: Boolean;
    @Input() content$: any;
    @Input() showSummary: false;
    @Input() reveal:Boolean = true;

    private subscriptions: Array<any> = [];
    private dataService: BehaviorSubject<Object>;

    constructor(
        private effects: CoreEffects,
        private route: ActivatedRoute,
        private cd: ChangeDetectorRef
    ) {
        this.dataService = new BehaviorSubject(null);
    }

    ngOnInit() {
        this.content$ = this.dataService.asObservable();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.list && changes.list.currentValue !== changes.list.previousValue) {
            
            if(this.list && this.list.data && this.list.data.length)
            {
                this.dataService.next(this.list);
            }
            else{
                this.effects.getAsyncChildDataAsObservable(this.dataService, this.list, this.route.snapshot.params, true);
            }
            
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
        if (this.dataService){
            this.dataService.complete();
            //this.dataService.unsubscribe();
            this.dataService = null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/list/lazy-item-list/lazy-item-list.component.ts